<template>
  <section class="banner-wrap">
    <div class="banner-box">
      <div class="content">
        <div class="title">{{ content?.serviceName || $t('sailing.dilu.SysBasicConfig' /** 系统基础配置 */) }}</div>
        <div class="description">{{ content?.description || $t('Gattaran_Homepage__XHuN' /** Gattaran系统基础配置功能集合，包括任务、审核、消息配置、问题反馈等 */) }}</div>
      </div>
      <img class="image" :src="removeProtocol(content?.image || defaultUrl)" />
    </div>
    <div v-if="applyShow" class="button-wrap">
      <pb-button class="button" type="primary" size="large" @click="toApply()">{{ $t('Gattaran_Homepage__XQjL' /** 申请权限 */) }}</pb-button>
    </div>
  </section>
</template>

<script>
import { rmProtocol } from '@/utils/tools';

export default {
  props: {
    applyShow: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultUrl: 'https://soda-static.didiglobal.com/static/soda_static/gattaran/General.png',
      nodeId: 0,
    };
  },
  methods: {
    removeProtocol(url) {
      return rmProtocol(url);
    },
    toApply() {
      window.open('/v2/gtr_console/authmanage/application/add');
      // this.$router.push('/gtr_console/authmanage/application/add');
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-wrap {
  display: flex;
  flex-direction: column;
  margin: 52px 22px 32px 26px;
  padding-left: 14px;
  padding-bottom: 10px;
  position: relative;
  border-bottom: 1px solid #e9eaee;
}
.banner-box {
  display: flex;
  flex-direction: row;
  height: 201px;
  .content {
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      color: #2c2f36;
      line-height: 40px;
      font-weight: 600;
    }
    .description {
      max-width: 600px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #8d9099;
      line-height: 24px;
      margin-top: 9px;
    }
  }
  .image {
    width: 332px;
    height: 204px;
    position: absolute;
    right: 0;
    bottom: 24px;
  }
}
</style>
